import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { yupResolver } from "@hookform/resolvers/yup";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import * as y from "yup";
import { MultiLevelMultipleCheckboxField } from "@/components/Form/Parts/index";
import styleButton from "@/styles/Button.module.scss";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import styles from "@/styles/Unsubscribe.module.scss";
import { useFormQuestionAnswerMutation, useFormQuestionsQuery } from "../../hooks/generated/graphql";
import TSButton from "../Buttons/TSButton";
import TSTextAreaField from "./Parts/TSTextAreaField";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// 質問レベルに応じて subTitle の「問」の数値が変化
const getSubTitle = (level, index) => `問${level}-${index}`;
function TextQuestion(_ref) {
  var _question$key_name;
  let {
    register,
    question,
    subTitle,
    visible
  } = _ref;
  const key = (_question$key_name = question.key_name) !== null && _question$key_name !== void 0 ? _question$key_name : "";
  return /*#__PURE__*/_jsx(TSTextAreaField, {
    name: `answer.${key}`
    // {...register(`answer.${key}`)}
    ,
    title: question.label || "",
    help: question.help_text || "",
    ref: register,
    subTitle: subTitle,
    placeholder: "\u30B3\u30E1\u30F3\u30C8",
    required: question.required || false,
    visible: visible
  });
}
function CheckboxQuestion(_ref2) {
  var _question$options, _errors$answer;
  let {
    control,
    question,
    errors,
    selectedQuestionValues,
    subTitle,
    visible
  } = _ref2;
  if (!question.key_name) return null;
  const options = ((_question$options = question.options) === null || _question$options === void 0 ? void 0 : _question$options.filter(option => option !== null)) || [];
  return /*#__PURE__*/_jsx(MultiLevelMultipleCheckboxField, {
    control: control,
    name: `answer.${question.key_name}`,
    help: question.help_text || "",
    required: question.required || false,
    options: options,
    title: question.label || "",
    error: errors === null || errors === void 0 || (_errors$answer = errors.answer) === null || _errors$answer === void 0 || (_errors$answer = _errors$answer[question.key_name]) === null || _errors$answer === void 0 ? void 0 : _errors$answer.message,
    subTitle: subTitle,
    selectedQuestionValues: selectedQuestionValues,
    defaultValue: [],
    row: undefined,
    visible: visible
  });
}
export default function QuestionnaireForm(_ref3) {
  var _level1Questions$conc;
  let {
    hideModal,
    showNotification,
    questionId,
    isSkipAble
  } = _ref3;
  const [formQuestionAnswer] = useFormQuestionAnswerMutation({
    onCompleted: data => {
      var _data$formQuestionAns;
      if (data !== null && data !== void 0 && (_data$formQuestionAns = data.formQuestionAnswer) !== null && _data$formQuestionAns !== void 0 && _data$formQuestionAns.answer_id) {
        hideModal();
        showNotification("アンケートに回答しました。", {
          time: 2000
        });
      }
    }
  });
  const {
    data
  } = useFormQuestionsQuery({
    variables: {
      id: questionId
    }
  });
  const questionFormData = useMemo(() => {
    var _data$formQuestions;
    return (data === null || data === void 0 || (_data$formQuestions = data.formQuestions) === null || _data$formQuestions === void 0 ? void 0 : _data$formQuestions.data) || [];
  }, [data]);
  const questionFormDataTyped = questionFormData;
  const level1QuestionsOriginal = questionFormDataTyped === null || questionFormDataTyped === void 0 ? void 0 : questionFormDataTyped.filter(q => {
    var _q$schema_group_name;
    return !!(q !== null && q !== void 0 && (_q$schema_group_name = q.schema_group_name) !== null && _q$schema_group_name !== void 0 && _q$schema_group_name.includes("level1"));
  });
  const level2QuestionsOriginal = questionFormDataTyped === null || questionFormDataTyped === void 0 ? void 0 : questionFormDataTyped.filter(q => {
    var _q$schema_group_name2;
    return !!(q !== null && q !== void 0 && (_q$schema_group_name2 = q.schema_group_name) !== null && _q$schema_group_name2 !== void 0 && _q$schema_group_name2.includes("level2"));
  });
  const level3QuestionsOriginal = questionFormDataTyped === null || questionFormDataTyped === void 0 ? void 0 : questionFormDataTyped.filter(q => {
    var _q$schema_group_name3;
    return !!(q !== null && q !== void 0 && (_q$schema_group_name3 = q.schema_group_name) !== null && _q$schema_group_name3 !== void 0 && _q$schema_group_name3.includes("level3"));
  });

  // hierarchy項目を追加
  const level1Questions = level1QuestionsOriginal === null || level1QuestionsOriginal === void 0 ? void 0 : level1QuestionsOriginal.map(element => {
    if (!(element !== null && element !== void 0 && element.key_name)) return null;
    const hierarchyList = [];
    return _objectSpread(_objectSpread({}, element), {
      hierarchy: hierarchyList
    });
  });

  // hierarchy項目を追加
  const level2Questions = level2QuestionsOriginal === null || level2QuestionsOriginal === void 0 ? void 0 : level2QuestionsOriginal.map(element => {
    var _element$schema_group;
    const hierarchyKey = element === null || element === void 0 || (_element$schema_group = element.schema_group_name) === null || _element$schema_group === void 0 || (_element$schema_group = _element$schema_group.split("_")) === null || _element$schema_group === void 0 ? void 0 : _element$schema_group[1];
    if (!hierarchyKey) return null;
    return _objectSpread(_objectSpread({}, element), {
      hierarchy: [hierarchyKey]
    });
    //    element.hierarchy = [hierarchyKey];
  });

  const level3Questions = level3QuestionsOriginal === null || level3QuestionsOriginal === void 0 ? void 0 : level3QuestionsOriginal.map(element => {
    var _element$schema_group2, _level2QuestionFromLe;
    const level3hierarchyKey = element === null || element === void 0 || (_element$schema_group2 = element.schema_group_name) === null || _element$schema_group2 === void 0 || (_element$schema_group2 = _element$schema_group2.split("_")) === null || _element$schema_group2 === void 0 ? void 0 : _element$schema_group2[1];
    if (!level3hierarchyKey) return null;
    const level2QuestionFromLevel3HierarchyKey = level2Questions.find(element => {
      if (!(element !== null && element !== void 0 && element.options)) return;
      return element === null || element === void 0 ? void 0 : element.options.some(option => {
        var _option$value;
        if (!option) return;
        if (!(option !== null && option !== void 0 && option.value)) return;
        return option === null || option === void 0 || (_option$value = option.value) === null || _option$value === void 0 ? void 0 : _option$value.includes(level3hierarchyKey);
      });
    });
    const level2hierarchyKey = level2QuestionFromLevel3HierarchyKey === null || level2QuestionFromLevel3HierarchyKey === void 0 || (_level2QuestionFromLe = level2QuestionFromLevel3HierarchyKey.schema_group_name) === null || _level2QuestionFromLe === void 0 || (_level2QuestionFromLe = _level2QuestionFromLe.split("_")) === null || _level2QuestionFromLe === void 0 ? void 0 : _level2QuestionFromLe[1];
    if (!level2hierarchyKey || !level3hierarchyKey) return null;
    return _objectSpread(_objectSpread({}, element), {
      hierarchy: [level2hierarchyKey, level3hierarchyKey]
    });
  });
  const allQuestionWithHierarchy = level1Questions === null || level1Questions === void 0 || (_level1Questions$conc = level1Questions.concat(level2Questions)) === null || _level1Questions$conc === void 0 ? void 0 : _level1Questions$conc.concat(level3Questions);
  const level3QuestionsNotNull = level3Questions.filter(element => !!element);

  // level2の質問が表示フラグをbooleanでもつステート
  const {
    0: level2QuestionsVisible,
    1: setLevel2QuestionsVisible
  } = useState([]);
  // level3の質問が表示フラグをbooleanでもつステート
  const {
    0: level3QuestionsVisible,
    1: setLevel3QuestionsVisible
  } = useState([]);
  // level1で選択済みのチェックボックスを管理するステート
  const {
    0: selectedLevel1Values,
    1: setSelectedLevel1Values
  } = useState({});
  // level2で選択済みのチェックボックスを管理するステート
  const {
    0: selectedLevel2Values,
    1: setSelectedLevel2Values
  } = useState({});

  // レベル1の選択肢変更ハンドラ
  const handleLevel1OptionChange = useCallback((questionKey, selectedValues) => {
    var _selectedLevel1Values;
    // チェックボックスのチェックが外されて場合
    // どのチェックボックスのチェックが
    if ((selectedLevel1Values === null || selectedLevel1Values === void 0 || (_selectedLevel1Values = selectedLevel1Values[`${questionKey}`]) === null || _selectedLevel1Values === void 0 ? void 0 : _selectedLevel1Values.length) > selectedValues.length) {
      var _selectedLevel1Values2;
      // 外した項目
      const diffList = selectedLevel1Values === null || selectedLevel1Values === void 0 || (_selectedLevel1Values2 = selectedLevel1Values[`${questionKey}`]) === null || _selectedLevel1Values2 === void 0 ? void 0 : _selectedLevel1Values2.filter(element => !(selectedValues !== null && selectedValues !== void 0 && selectedValues.includes(element)));
      const removedKey = diffList === null || diffList === void 0 ? void 0 : diffList[0];
    }

    // レベル1の選択肢の更新
    setSelectedLevel1Values(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [questionKey]: selectedValues
    }));
  }, [selectedLevel1Values]);

  // レベル2の選択肢変更ハンドラ
  const handleLevel2OptionChange = useCallback((questionKey, selectedValues) => {
    setSelectedLevel2Values(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [questionKey]: selectedValues
    }));
  }, []);

  // レベル2の質問を更新する関数
  const updateLevel2QuestionsFromLevel1 = useCallback(() => {
    const selectedLevel1ValuesList = Object.values(selectedLevel1Values).flat();
    const newLevel2Questions = questionFormData.filter(q => q !== null && selectedLevel1ValuesList.some(value => {
      var _q$schema_group_name4;
      return (_q$schema_group_name4 = q.schema_group_name) === null || _q$schema_group_name4 === void 0 ? void 0 : _q$schema_group_name4.startsWith(`level2_${value}`);
    }));
    setLevel2QuestionsVisible(newLevel2Questions);
  }, [selectedLevel1Values, questionFormData]);

  // レベル3の質問をlevel2のチェックボックスから更新する関数
  const updateLevel3QuestionsFromLevel2 = useCallback(() => {
    const selectedLevel2ValuesList = Object.values(selectedLevel2Values).flat();
    const newLevel3Questions = questionFormData.filter(q => q !== null && selectedLevel2ValuesList.some(value => {
      var _q$schema_group_name5;
      return (_q$schema_group_name5 = q.schema_group_name) === null || _q$schema_group_name5 === void 0 ? void 0 : _q$schema_group_name5.startsWith(`level3_${value}`);
    }));
    setLevel3QuestionsVisible(newLevel3Questions);
  }, [selectedLevel2Values, questionFormData]);
  useEffect(() => {
    updateLevel2QuestionsFromLevel1();
  }, [updateLevel2QuestionsFromLevel1]);
  useEffect(() => {
    updateLevel3QuestionsFromLevel2();
  }, [updateLevel3QuestionsFromLevel2]);

  // バリデーション
  const schema = useMemo(() => {
    const answerSchema = (() => {
      if (questionFormData.length > 0) {
        return Object.fromEntries(questionFormData.filter(data => data !== null && data.required === true).map(data => {
          if ((data === null || data === void 0 ? void 0 : data.type) === "string") {
            return [(data === null || data === void 0 ? void 0 : data.key_name) || "", y.string().required("回答を入力してください。")];
          } else if ((data === null || data === void 0 ? void 0 : data.type) === "const") {
            return [(data === null || data === void 0 ? void 0 : data.key_name) || "", y.array().min(1, "選択してください。")];
          }
          return [(data === null || data === void 0 ? void 0 : data.key_name) || "", y.mixed()];
        }));
      }
      return {};
    })();
    return y.object({
      answer: y.object(answerSchema),
      questionId: y.number()
    });
  }, [questionFormData]);
  const {
    formState,
    handleSubmit,
    register,
    control
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const {
    errors,
    isValid,
    isSubmitting
  } = formState;
  const level2QuestionsVisibleSchemaGroupNameList = level2QuestionsVisible === null || level2QuestionsVisible === void 0 ? void 0 : level2QuestionsVisible.map(element => element === null || element === void 0 ? void 0 : element.schema_group_name);
  const level3QuestionsVisibleSchemaGroupNameList = level3QuestionsVisible === null || level3QuestionsVisible === void 0 ? void 0 : level3QuestionsVisible.map(element => element === null || element === void 0 ? void 0 : element.schema_group_name);

  // アンケート回答
  const handleAnswerSubmit = useCallback(async data => {
    try {
      const formattedAnswer = Object.entries(data.answer).reduce((acc, _ref4) => {
        var _visibleFromLevel1Sel;
        let [key, value] = _ref4;
        // ループでの質問
        const currentQuestion = allQuestionWithHierarchy === null || allQuestionWithHierarchy === void 0 ? void 0 : allQuestionWithHierarchy.find(element => (element === null || element === void 0 ? void 0 : element.key_name) === key);
        // 選択をはずした項目は小要素含めデータを連携しない
        let notVisible = true;
        const schemaGroupName = (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.schema_group_name) || "";

        //  visibilityFromIntersection 定義する

        const visibleFromLevel1Selected = Object.values(selectedLevel1Values).flat().flat();
        const hierarchyList = (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.hierarchy) || [];
        const visibilityFromIntersection = (visibleFromLevel1Selected === null || visibleFromLevel1Selected === void 0 || (_visibleFromLevel1Sel = visibleFromLevel1Selected.filter(element => hierarchyList.includes(element))) === null || _visibleFromLevel1Sel === void 0 ? void 0 : _visibleFromLevel1Sel.length) > 0;
        if (schemaGroupName !== null && schemaGroupName !== void 0 && schemaGroupName.includes("level1")) {
          notVisible = false;
        } else if (schemaGroupName !== null && schemaGroupName !== void 0 && schemaGroupName.includes("level2") && !!level2QuestionsVisibleSchemaGroupNameList.includes(schemaGroupName)) {
          notVisible = false;
        } else if (!!level3QuestionsVisibleSchemaGroupNameList.includes(schemaGroupName) && visibilityFromIntersection) {
          notVisible = false;
        }
        if (typeof value === "undefined" || notVisible) {
          acc[key] = "";
        } else if (Array.isArray(value)) {
          acc[key] = value;
        } else {
          acc[key] = String(value);
        }
        return acc;
      }, {});
      const params = {
        variables: {
          id: Number(questionId),
          values: JSON.stringify(formattedAnswer)
        }
      };
      formQuestionAnswer(params);
    } catch (e) {
      console.error("エラーが発生しました:", e);
    }
  }, [formQuestionAnswer, questionId, allQuestionWithHierarchy, level2QuestionsVisibleSchemaGroupNameList, level3QuestionsVisibleSchemaGroupNameList, selectedLevel1Values]);
  return /*#__PURE__*/_jsxs("form", {
    noValidate: true,
    onSubmit: handleSubmit(handleAnswerSubmit),
    className: processStyles.questionContainer,
    children: [/*#__PURE__*/_jsx("h2", {
      children: "\u30A2\u30F3\u30B1\u30FC\u30C8"
    }), /*#__PURE__*/_jsx("div", {
      className: processStyles.contentQuestionWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.questionnaireContent,
        children: [/*#__PURE__*/_jsx("p", {
          className: `${processStyles.questionnaireDescription} ${processStyles.level1Description}`,
          children: "\u3088\u308D\u3057\u3051\u308C\u3070\u3001\u4ECA\u5F8C\u306E\u30B5\u30FC\u30D3\u30B9\u6539\u5584\u306E\u305F\u3081\u30A2\u30F3\u30B1\u30FC\u30C8\u306B\u3054\u5354\u529B\u304F\u3060\u3055\u3044"
        }), /*#__PURE__*/_jsxs("div", {
          className: `${styles.questionSurvey} ${styles.questionSurveyTS}`,
          children: [/*#__PURE__*/_jsx("div", {
            className: processStyles.questionnaireDescription
          }), level1Questions === null || level1Questions === void 0 ? void 0 : level1Questions.map((question, index) => {
            if (question === null) return null;
            const subTitle = getSubTitle(1, index + 1);
            if (question.type === "string") {
              return /*#__PURE__*/_jsx(TextQuestion, {
                register: register,
                subTitle: subTitle,
                question: question,
                errors: errors,
                title: question.label,
                visible: true
              }, `question-${index}`);
            } else if (question.type === "const") {
              return /*#__PURE__*/_jsx(CheckboxQuestion, {
                control: control,
                question: question,
                subTitle: subTitle,
                errors: errors,
                selectedQuestionValues: values => handleLevel1OptionChange(question.key_name || "", values),
                visible: true
              }, `question-${index}`);
            }
          }), level2Questions === null || level2Questions === void 0 ? void 0 : level2Questions.map((question, index) => {
            if (question === null) return null;
            const subTitle = getSubTitle(2, index + 1);
            if (question.type === "string") {
              return /*#__PURE__*/_jsx(TextQuestion, {
                register: register,
                subTitle: subTitle,
                question: question,
                errors: errors,
                title: question.label,
                visible: !!level2QuestionsVisibleSchemaGroupNameList.includes(question === null || question === void 0 ? void 0 : question.schema_group_name)
              }, `question-${index}`);
            } else if (question.type === "const") {
              return /*#__PURE__*/_jsx(CheckboxQuestion, {
                control: control,
                question: question,
                subTitle: subTitle,
                errors: errors,
                selectedQuestionValues: values => handleLevel2OptionChange(question.key_name || "", values),
                visible: !!level2QuestionsVisibleSchemaGroupNameList.includes(question === null || question === void 0 ? void 0 : question.schema_group_name)
              }, `question-${index}`);
            }
            return null;
          }), level3QuestionsNotNull === null || level3QuestionsNotNull === void 0 ? void 0 : level3QuestionsNotNull.map((question, index) => {
            var _visibleFromLevel1Sel2;
            if (question === null) return null;
            const subTitle = getSubTitle(3, index + 1);
            const visibleFromLevel1Selected = Object.values(selectedLevel1Values).flat().flat();
            const hierarchyList = question === null || question === void 0 ? void 0 : question.hierarchy;
            const visibilityFromIntersection = (visibleFromLevel1Selected === null || visibleFromLevel1Selected === void 0 || (_visibleFromLevel1Sel2 = visibleFromLevel1Selected.filter(element => hierarchyList.includes(element))) === null || _visibleFromLevel1Sel2 === void 0 ? void 0 : _visibleFromLevel1Sel2.length) > 0;
            if ((question === null || question === void 0 ? void 0 : question.type) === "string") {
              return /*#__PURE__*/_jsx(TextQuestion, {
                register: register,
                question: question,
                subTitle: subTitle,
                errors: errors,
                title: question === null || question === void 0 ? void 0 : question.label,
                visible: !!level3QuestionsVisibleSchemaGroupNameList.includes(question === null || question === void 0 ? void 0 : question.schema_group_name) && visibilityFromIntersection
              }, `question-${index}`);
            } else if ((question === null || question === void 0 ? void 0 : question.type) === "const") {
              return /*#__PURE__*/_jsx(CheckboxQuestion, {
                control: control,
                question: question,
                subTitle: subTitle,
                errors: errors,
                selectedQuestionValues: () => {},
                visible: !!level3QuestionsVisibleSchemaGroupNameList.includes(question === null || question === void 0 ? void 0 : question.schema_group_name) && visibilityFromIntersection
              }, `question-${index}`);
            }
            return null;
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: `${formStyles.btnArea} ${formStyles.multiple} ${formStyles.minWidth10em}`,
      children: [isSkipAble && /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: () => hideModal(),
        className: styleButton.backButtonStyled,
        children: "\u623B\u308B"
      }), /*#__PURE__*/_jsx(TSButton, {
        fillCautionColor: true,
        fontFixed: true,
        type: "submit",
        disabled: !isValid,
        loading: isSubmitting,
        children: "\u56DE\u7B54"
      })]
    })]
  });
}